import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';

import { PageConstant } from 'src/app/constants';
import { GeneralHelper } from 'src/app/helpers';
import {
  BaseMenuItem,
  NormalizedTicket,
  Product,
  Ticket
} from 'src/app/models';
import { TicketProvider } from 'src/app/providers';
import { AppSelectors } from 'src/app/store/app/app.selectors';

export interface IDonationModal {
  menuItem: Product;
  ticket: Ticket | NormalizedTicket;
}

@Component({
  templateUrl: './donation.modal.html',
  styleUrls: ['./donation.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DonationModal implements OnInit {
  @Input() menuItem: Product;
  @Input() ticket: Ticket | NormalizedTicket;

  @ViewSelectSnapshot(AppSelectors.getSelectedLocaleCode)
  currentLang: string;

  suggestedAmount: number;
  totalAmount: number;
  amount = 0;
  isCustomAmount = false;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private ticketProvider: TicketProvider
  ) {}

  ngOnInit() {
    if (this.ticket) {
      this.totalAmount = Math.ceil(this.ticket.outstanding_balance);
      this.suggestedAmount = this.totalAmount - this.ticket.outstanding_balance;
    }

    this.amount = this.suggestedAmount;
  }

  back() {
    this.isCustomAmount = false;
  }

  saveAmount() {
    this.suggestedAmount = +this.amount;
    this.totalAmount = this.ticket.outstanding_balance + this.suggestedAmount;
    this.back();
  }

  customAmount() {
    this.isCustomAmount = true;
    this.amount = GeneralHelper.asDecimal(this.suggestedAmount);
  }

  onCloseModal(navigateToPayment = false) {
    this.modalController.dismiss();
    if (navigateToPayment) {
      this.navController.navigateRoot([PageConstant.PAYMENTS_PAGE]);
    }
  }

  addCharityProduct() {
    if (!this.menuItem) {
      return;
    }

    const baseMenuItem: BaseMenuItem = {
      ...this.menuItem,
      price: this.amount,
      quantity: 1
    };

    this.ticketProvider.ticketItemAddingHandler({
      menuItem: baseMenuItem,
      ticket_uuid: this.ticket?.device_ticket_uuid
    });
    this.onCloseModal(true);
  }

  onNumericKeyboardInput($event: string) {
    this.amount = +$event;
  }
}
